import { jsx, jsxs } from "react/jsx-runtime";
const SvgHousehold = (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M1 11V21H6V15H10V21H15V11L8 6L1 11Z", fill: "currentColor", fillOpacity: 0.9 }),
  /* @__PURE__ */ jsx("path", { d: "M10 3V4.97L17 9.97V11H19V13H17V15H19V17H17V21H23V3H10ZM19 9H17V7H19V9Z", fill: "currentColor", fillOpacity: 0.9 })
] });
export default SvgHousehold;
